export default "__VITE_ASSET__BmaZIHlM__"